module.exports = __webpack_public_path__ + "static/media/Semesta Kumbo Logo.c56757dc.png";